import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you see an `}<inlineCode parentName="p">{`EACCES`}</inlineCode>{` error when you try to `}<a parentName="p" {...{
        "href": "downloading-and-installing-packages-globally"
      }}>{`install a package globally`}</a>{`, you can either:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Reinstall npm with a node version manager (recommended),`}</p>
        <p parentName="li"><strong parentName="p">{`or`}</strong></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Manually change npm's default directory`}</p>
      </li>
    </ul>
    <h2>{`Reinstall npm with a node version manager`}</h2>
    <p>{`This is the best way to avoid permissions issues. To reinstall npm with a node version manager, follow the steps in "`}<a parentName="p" {...{
        "href": "downloading-and-installing-node-js-and-npm"
      }}>{`Downloading and installing Node.js and npm`}</a>{`". You do not need to remove your current version of npm or Node.js before installing a node version manager.`}</p>
    <h2>{`Manually change npm's default directory`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` This section does not apply to Microsoft Windows.`}</p>
    </Note>
    <p>{`To minimize the chance of permissions errors, you can configure npm to use a different directory. In this example, you will create and use hidden directory in your home directory.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Back up your computer.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the command line, in your home directory, create a directory for global installations:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`mkdir ~/.npm-global
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Configure npm to use the new directory path:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm config set prefix '~/.npm-global'
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In your preferred text editor, open or create a `}<inlineCode parentName="p">{`~/.profile`}</inlineCode>{` file and add this line:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`export PATH=~/.npm-global/bin:$PATH
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the command line, update your system variables:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`source ~/.profile
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To test your new configuration, install a package globally without using `}<inlineCode parentName="p">{`sudo`}</inlineCode>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm install -g jshint
`}</code></pre>
      </li>
    </ol>
    <p>{`Instead of steps 3-5, you can use the corresponding ENV variable (e.g. if you don't want to modify `}<inlineCode parentName="p">{`~/.profile`}</inlineCode>{`):`}</p>
    <pre><code parentName="pre" {...{}}>{`NPM_CONFIG_PREFIX=~/.npm-global
`}</code></pre>
    <Note mdxType="Note">
      <p><strong parentName="p">{`npx: an alternative to running global commands`}</strong></p>
      <p>{`If you are using npm version 5.2 or greater, you may want to consider `}<a parentName="p" {...{
          "href": "https://www.npmjs.com/package/npx"
        }}>{`npx`}</a>{` as an alternative way to run global commands, especially if you only need a command occasionally. For more information, see `}<a parentName="p" {...{
          "href": "https://medium.com/@maybekatz/introducing-npx-an-npm-package-runner-55f7d4bd282b"
        }}>{`this article about npx`}</a>{`.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      